module.exports = __webpack_public_path__ + "img/card-D3DBE9.fa2c50a0.png";